var E = /* @__PURE__ */ ((D) => (D.PLANNED = "PLANNED", D.STARTED = "STARTED", D.FINISHED = "FINISHED", D))(E || {});
export {
  E as WorkoutCompletionStatus
};
